<template>
	<FootprintTableSingleAdd />
</template>

<script>
import FootprintTableSingleAdd from '@/components/FootprintTable/FootprintTableSingle/FootprintTableSingleAdd'

export default {
	name: "FootprintPageSingleAdd",
	components: {
		FootprintTableSingleAdd
	}
}
</script>

<style scoped>

</style>